__turbopack_context__.v({
  "formProductCard": "m56Z3q_formProductCard",
  "formProductCardCollapse": "m56Z3q_formProductCardCollapse",
  "formProductCardContent": "m56Z3q_formProductCardContent",
  "formProductCardContentTitle": "m56Z3q_formProductCardContentTitle",
  "formProductCardHeader": "m56Z3q_formProductCardHeader",
  "formProductCardHeaderWrapper": "m56Z3q_formProductCardHeaderWrapper",
  "formProductCardSubTitle": "m56Z3q_formProductCardSubTitle",
  "formProductCardTitle": "m56Z3q_formProductCardTitle",
  "formProductCardToggleContent": "m56Z3q_formProductCardToggleContent",
  "open": "m56Z3q_open",
});
